var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10,17.4c-6.2,0-9.7-6.8-9.8-7.1c-0.1-0.2-0.1-0.5,0-0.7C0.3,9.4,3.8,2.6,10,2.6c6.2,0,9.7,6.8,9.8,7.1 c0.1,0.2,0.1,0.5,0,0.7C19.7,10.6,16.2,17.4,10,17.4z M1.7,10c0.8,1.3,3.7,5.9,8.3,5.9c4.6,0,7.6-4.6,8.3-5.9 c-0.8-1.3-3.7-5.9-8.3-5.9C5.4,4.1,2.4,8.7,1.7,10z M10,13.3c-1.8,0-3.3-1.5-3.3-3.3S8.2,6.8,10,6.8s3.3,1.5,3.3,3.3 S11.8,13.3,10,13.3z M10,8.3C9,8.3,8.3,9,8.3,10S9,11.8,10,11.8s1.8-0.8,1.8-1.8S11,8.3,10,8.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.91c3cddd99d70c2770baab33ab0f476a.svg";
export { ForwardRef as ReactComponent };